import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Determine if header should be dark based on the current page
  const isDark = location.pathname === '/le-cabinet' || location.pathname === '/domaines-intervention';
  const logoSrc = isDark
    ? "https://cabinet-ben-nasr.s3.eu-central-1.amazonaws.com/LogoWhite.png"
    : "https://cabinet-ben-nasr.s3.eu-central-1.amazonaws.com/Layer_1.png";

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const burgerColor = isDark ? '#F4F1EA' : '#1A2D47';

  return (
    <header className={`header ${isDark ? 'header-dark' : 'header-light'}`}>
      <div className="header-content">
        <Link to="/" className="logo">
          <img
            src={logoSrc}
            alt="Ben Nasr Logo"
          />
        </Link>
        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} onClick={closeMenu}>Accueil</Link>
          <Link to="/le-cabinet" className={`nav-link ${location.pathname === '/le-cabinet' ? 'active' : ''}`} onClick={closeMenu}>Le Cabinet</Link>
          <Link to="/nos-avocats" className={`nav-link ${location.pathname === '/nos-avocats' ? 'active' : ''}`} onClick={closeMenu}>Nos avocats</Link>
          <Link to="/domaines-intervention" className={`nav-link ${location.pathname === '/domaines-intervention' ? 'active' : ''}`} onClick={closeMenu}>Domaines d'Intervention</Link>
          <Link to="/contact" className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`} onClick={closeMenu}>Contact</Link>
        </nav>
        <div className="burger-menu" onClick={toggleMenu}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.4291 11.1436H2.57199C2.0986 11.1436 1.71484 11.5273 1.71484 12.0007C1.71484 12.4741 2.0986 12.8579 2.57199 12.8579H21.4291C21.9025 12.8579 22.2863 12.4741 22.2863 12.0007C22.2863 11.5273 21.9025 11.1436 21.4291 11.1436Z" fill={burgerColor}/>
            <path d="M21.4291 5.14258H2.57199C2.0986 5.14258 1.71484 5.52635 1.71484 5.99975C1.71484 6.47315 2.0986 6.85692 2.57199 6.85692H21.4291C21.9025 6.85692 22.2863 6.47315 22.2863 5.99975C22.2863 5.52635 21.9025 5.14258 21.4291 5.14258Z" fill={burgerColor}/>
            <path d="M21.4291 17.1426H2.57199C2.0986 17.1426 1.71484 17.5263 1.71484 17.9997C1.71484 18.4732 2.0986 18.8569 2.57199 18.8569H21.4291C21.9025 18.8569 22.2863 18.4732 22.2863 17.9997C22.2863 17.5263 21.9025 17.1426 21.4291 17.1426Z" fill={burgerColor}/>
          </svg>
        </div>
      </div>
    </header>
  );
};

export default Header;
